import React from 'react'

import * as S from './styles'

import Icon from '../icon'

import Icons from './icons-enum'

import IProps from './props'

const Togglable = ({
  title, message, isOpen, onToggle,
}: IProps) => {
  const icon = isOpen ? Icons.ARROW_UP : Icons.ARROW_DOWN

  return (
    <S.Container>
      <S.Title isOpen={isOpen} onClick={onToggle}>
        {title}
        {' '}
        <div>
          <S.IconContainer isOpen={isOpen}>
            <Icon name={icon} />
          </S.IconContainer>
        </div>
      </S.Title>
      <S.Content isOpen={isOpen}>{message}</S.Content>
    </S.Container>
  )
}

export default Togglable
